<template>
  <div>

    <div class="sayfahead">
      <h1>Mesken Listesi</h1>
      <el-button v-if="SeciliBina && Yetki" type="info" size="small" class="YeniBtn" @click="this.YeniBtn">
        {{ Sayfa.ButtonAdi }}
      </el-button>
    </div>
    <div class="icerik">
      <Yukleniyor :data="lo"></Yukleniyor>
      <div class="ekranbos" v-if="!Liste || !SeciliBina">Bina Seçiniz</div>
      <el-table
        v-if="Liste && SeciliBina"
        :data="Liste.filter(data => !search || data.kNo.toLowerCase().includes(search.toLowerCase()))"
        class="golgetable pt-0"
        width="100%"
        :height="Height"
        fixed>
        <el-table-column
          label="No"
          prop="kNo"
          width="100"
          current-row-key="number">
        </el-table-column>
        <el-table-column
          label="Kat"
          prop="Kat"
          width="100">
        </el-table-column>
        <el-table-column
          label="m2"
          prop="m2"
          width="100">
        </el-table-column>
        <el-table-column
          label="Tanım"
          prop="Tanim"
          width="200">
        </el-table-column>
        <el-table-column
          align="right">
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="search"
              size="medium"
              :placeholder="Sayfa.Arama"/>
          </template>
          <template slot-scope="scope">
            <el-button-group>
              <el-tooltip v-if="Yetki" class="item" effect="dark" :content="Sayfa.DuzenleAdi"
                          placement="top-start">
                <i
                  class="feather-edit-2  tableibtn text-primary"
                  @click="DuzenleBtn(scope.row)"></i>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="Sayfa.Adi"
                          placement="top-start">
                <i
                  class="feather-airplay tableibtn text-success"
                  @click="$router.push('/yonetim/mesken/'+scope.row.id)">
                </i>
              </el-tooltip>
              <el-tooltip v-if="scope.row.Silinebilir && Yetki" class="item" effect="dark"
                          :content="Sayfa.SilAdi"
                          placement="top-start">
                <i
                  class="feather-trash tableibtn text-danger"
                  @click="SilOnay(scope.row.id)">
                </i>
              </el-tooltip>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
    </div>


    <MeskenDetay :data="Form" v-if="ModalOlayi" :ModalOlayi="ModalOlayi"
                 @ModalOlayi="SayfaYukle"></MeskenDetay>
  </div>
</template>
<script>

import MeskenDetay from "../../../components/Pack/Yonetim/mesken/MeskenDetay";
import Yukleniyor from "../../../components/Doc/Yukleniyor";

export default {
  components: {Yukleniyor, MeskenDetay},
  data() {
    return {
      Height: window.innerHeight - 150,
      Yetki: false,
      ModalOlayi: false,
      dModalOlayi: false,
      Baslik: null,
      IndirimHata: null,
      lo: false,
      Indirim: {
        Kategori_id: null,
        Tanim: null,
        Oran: 0,
        basTarihi: null,
        bitTarihi: null

      },
      Kategoriler: [],
      Sayfa: {
        ButtonAdi: 'Yeni Mesken Ekle',
        DuzenleAdi: 'Mesken Düzenle',
        SilAdi: 'Mesken Sil',
        Button: null,
        Adi: 'Detay',
        Menu: [],
        MenuDisplay: null,
      },
      Liste: [],

      Form: {
        Baslik: null,
        kNo: null,
        Kat: null,
        m2: null,
        Mesken_Turu_id: null,
        id: null,
        Bina_id: null,
        IndirimListe: [],
      },
      Mesken_Turu: [],
      search: '',
      SeciliBina: null,
      Detay_id: null
    }
  },
  methods: {
    SayfaYukle() {
      this.ModalOlayi = false;
      this.$store.dispatch("Get", {path: 'yonetim/mesken/' + this.SeciliBina})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Liste = response.Liste
            this.lo = false
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
      this.Yetki = this.$store.getters.Yetki.yonetim == 2 ? true : false;
    },
    SilOnay(id) {
      this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
        confirmButtonText: this.$t('eGenel.2'),
        cancelButtonText: this.$t('eGenel.3'),
        type: 'warning'
      }).then(() => {
        this.Sil(id)
      }).catch(() => {
        this.$message.info(this.$t('eGenel.8'));
      });
    },
    Sil(id) {
      this.$store.dispatch("Delete", {...this.Form, path: 'yonetim/mesken/' + id})
        .then(response => {
          if (response.Durum == "OK") {
            this.dModalOlayi = false;
            this.$message.success(response.Mesaj);
            this.SayfaYukle();
          } else {
            this.$message.warning(response.Mesaj);
            this.hata = response.Hata;
          }
        })

    },
    DuzenleBtn(Veri) {

      this.Form = Veri;
      this.Form.Baslik = this.Sayfa.DuzenleAdi;
      this.ModalOlayi = true;


    },
    YeniBtn() {
      this.ModalOlayi = true;
      this.Form.Baslik = this.Sayfa.ButtonAdi;
      this.Form.kNo = null;
      this.Form.Kat = null;
      this.Form.m2 = null;
      this.Form.Mesken_Turu_id = null;
      this.Form.id = null;
      this.Form.IndirimListe = []
    }


  },
  created() {
    this.$store.commit("SayfaBilgi", this.Sayfa);
    if (this.$store.getters.BinaBilgi) {
      this.BinaBilgi = this.$store.getters.BinaBilgi;
      this.SeciliBina = this.BinaBilgi.id;
      this.Form.Bina_id = this.SeciliBina;
      this.SayfaYukle();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Yonetim/mesken/Liste.vue